import { z } from 'zod';

export const FIELD_CONFIG_ENTITIES = ['customer', 'vehicle', 'order'] as const;
export type FieldConfigEntity = (typeof FIELD_CONFIG_ENTITIES)[number];

export const FieldConfigEntitySchema = z.enum(FIELD_CONFIG_ENTITIES);

export const UpsertTenantFieldConfigBodySchema = z.object({
  label: z.string().nullable().optional(),
  required: z.boolean(),
  visible: z.boolean(),
  displayOrder: z.number().int(),
  locked: z.boolean(),
});

export type UpsertTenantFieldConfigBody = z.infer<typeof UpsertTenantFieldConfigBodySchema>;

export const UpsertPlaceFieldConfigBodySchema = z.object({
  label: z.string().nullable().optional(),
  required: z.boolean().nullable().optional(),
  visible: z.boolean().nullable().optional(),
  displayOrder: z.number().int().nullable().optional(),
});

export type UpsertPlaceFieldConfigBody = z.infer<typeof UpsertPlaceFieldConfigBodySchema>;

export const TenantFieldConfigItemSchema = z.object({
  id: z.uuid(),
  entity: FieldConfigEntitySchema,
  fieldKey: z.string().min(1),
  label: z.string().nullable(),
  required: z.boolean(),
  visible: z.boolean(),
  displayOrder: z.number().int(),
  locked: z.boolean(),
  updatedAt: z.string(),
});

export const PlaceFieldConfigItemSchema = z.object({
  id: z.uuid(),
  entity: FieldConfigEntitySchema,
  fieldKey: z.string().min(1),
  label: z.string().nullable(),
  required: z.boolean().nullable(),
  visible: z.boolean().nullable(),
  displayOrder: z.number().int().nullable(),
  updatedAt: z.string(),
});

export const ListTenantFieldConfigsResponseSchema = z.object({
  items: z.array(TenantFieldConfigItemSchema),
});

export type ListTenantFieldConfigsResponse = z.infer<typeof ListTenantFieldConfigsResponseSchema>;

export const ListPlaceFieldConfigsResponseSchema = z.object({
  placeId: z.uuid(),
  items: z.array(PlaceFieldConfigItemSchema),
});

export type ListPlaceFieldConfigsResponse = z.infer<typeof ListPlaceFieldConfigsResponseSchema>;

export const UpsertTenantFieldConfigResponseSchema = TenantFieldConfigItemSchema;
export type UpsertTenantFieldConfigResponse = z.infer<typeof UpsertTenantFieldConfigResponseSchema>;

export const UpsertPlaceFieldConfigResponseSchema = PlaceFieldConfigItemSchema;
export type UpsertPlaceFieldConfigResponse = z.infer<typeof UpsertPlaceFieldConfigResponseSchema>;

export const ResolveFieldConfigQuerySchema = z.object({
  entity: FieldConfigEntitySchema,
  fieldKey: z.string().min(1),
});

export const ResolveFieldConfigResponseSchema = z.object({
  entity: FieldConfigEntitySchema,
  fieldKey: z.string().min(1),
  label: z.string().nullable(),
  required: z.boolean(),
  visible: z.boolean(),
  displayOrder: z.number().int(),
  resolvedFrom: z.enum(['TENANT', 'PLACE']),
});

export type ResolveFieldConfigResponse = z.infer<typeof ResolveFieldConfigResponseSchema>;
